(function () {
  var SWIPE_THRESHOLD_PX = 44;
  var SWIPE_MAX_VERTICAL_PX = 72;

  function roleForSlide(slideIndex, index, total) {
    if (total === 1) {
      return slideIndex === index ? 'active' : 'hidden';
    }

    if (slideIndex === index) return 'active';

    if (total === 2) {
      if (slideIndex === (index + 1) % total) return 'next';
      if (slideIndex === (index - 1 + total) % total) return 'prev';
      return 'hidden';
    }

    var offset = (slideIndex - index + total) % total;
    if (offset === 1) return 'next';
    if (offset === total - 1) return 'prev';
    return 'hidden';
  }

  function bindGallerySwipe(root, onSwipe) {
    var viewport = root.querySelector('.amc-eo__gallery-viewport');
    if (!viewport || typeof onSwipe !== 'function') return;

    var pointerStart = null;

    function resetPointer() {
      pointerStart = null;
      viewport.classList.remove('is-dragging');
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
      };
      viewport.classList.add('is-dragging');
      if (viewport.setPointerCapture && event.pointerId != null) {
        try {
          viewport.setPointerCapture(event.pointerId);
        } catch (_error) {
          /* ignore */
        }
      }
    }

    function onPointerUp(event) {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;

      var dx = event.clientX - pointerStart.x;
      var dy = event.clientY - pointerStart.y;
      resetPointer();

      if (Math.abs(dy) > SWIPE_MAX_VERTICAL_PX) return;
      if (Math.abs(dx) < SWIPE_THRESHOLD_PX) return;

      if (dx < 0) onSwipe(1);
      else onSwipe(-1);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', resetPointer);
  }

  function initGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-amc-eo-slide]'));
    var total = slides.length;
    if (total === 0) return;

    var prevBtn = root.querySelector('[data-amc-eo-prev]');
    var nextBtn = root.querySelector('[data-amc-eo-next]');
    var index = 0;

    function setButtonsDisabled(disabled) {
      if (prevBtn) prevBtn.disabled = disabled || total <= 1;
      if (nextBtn) nextBtn.disabled = disabled || total <= 1;
    }

    function render() {
      slides.forEach(function (slide, slideIndex) {
        var role = roleForSlide(slideIndex, index, total);
        slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');
        slide.classList.add('is-' + role);
      });
    }

    function go(delta) {
      if (total <= 1) return;
      index = (index + delta + total) % total;
      render();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(1);
      });
    }

    bindGallerySwipe(root, go);

    render();
    setButtonsDisabled(false);
  }

  function initSection(section) {
    var gallery = section.querySelector('[data-amc-eo-gallery]');
    if (gallery) initGallery(gallery);
  }

  function initAll() {
    document.querySelectorAll('[data-amc-eo-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-amc-eo-section]')) {
      initSection(event.target.querySelector('[data-amc-eo-section]'));
    }
  });
})();
